/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_RewindInputs */



/**
* | output |
* | --- |
* | "Rewind through video (foot fedal recommended)" |
*
* @param {Shortcut_Keys_Desc_Toggle_RewindInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_rewind = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_RewindInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_RewindInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour rapide dans la video (pedale recommandee)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video zurückspulen (Fußfesselung empfohlen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riavvolgi il video (si consiglia l'uso del piede)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотайте видео (рекомендуется использовать педаль).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rebobinar el video (se recomienda usar el pie)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频倒带（建议使用脚踏式播放器）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオを巻き戻す（徒歩での視聴を推奨）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो को रिवाइंड करके देखें (फुट पैडल का इस्तेमाल करने की सलाह दी जाती है)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Retroceda o vídeo (recomenda-se o uso do pedal)")
	return /** @type {LocalizedString} */ ("Rewind through video (foot fedal recommended)")
});